export default "__VITE_ASSET__CKY3xQxE__"